export default __webpack_public_path__ + "static/media/medium.32466a3c.woff";